import { _ as o } from "./index742.mjs";
import { g as e } from "./index793.mjs";
import "./index787.mjs";
import { p as t } from "./index788.mjs";
import { p as s } from "./index794.mjs";
var i = o, m = e, p = t.CONSTRUCTOR, a = s;
m("Promise");
i({ target: "Promise", stat: !0, forced: p }, {
  resolve: function(r) {
    return a(this, r);
  }
});
